import { gql } from '@apollo/client';

export const ADD_CORE_USER_PERMISSION = gql`
  mutation addCoreAdminPermissions($email: String!) {
    addCoreAdminPermissions(email: $email)
  }
`;

export const REVOKE_USER_PERMISSION = gql`
  mutation revokeUserPermission($email: String!, $permission: String!) {
    revokeUserPermission(email: $email, permission: $permission)
  }
`;

export const ADD_PERMISSION = gql`
  mutation addUserPermission($email: String!, $permission: String!) {
    addUserPermission(email: $email, permission: $permission)
  }
`;
